<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsFormItem',
  
})
</script>
<template>
  <t-form-item class="TlbsFormItem">
    <template #label>
      <div v-if="required" class="tlbs-form-item-label">
        {{ label }}
        <i class="icon-required">*</i>
      </div>
    </template>
    <slot />
  </t-form-item>
</template>

<script setup lang="ts" name="TlbsFormItem">
interface Props {
  required?: boolean;
  label: string;
}

withDefaults(defineProps<Props>(), {
  required: false,
  label: '',
});
</script>
